<template>
  <AccessHandler
    :requiredRoleGroups="roleGroups"
    @accessChanged="(a: boolean) => (hasAccess = a)"
  />
  <div class="workflow-ingredients-page">
    <MasterPage>
      <template v-if="hasAccess" v-slot:content>
        <IngredientDetailsView />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import MasterPage from "../MasterPage.vue";
import { useMainStore } from "@/stores/useMainStore";
import GlobalFooter from "@/views/GlobalFooter.vue";
import IngredientDetailsView from "./WorkflowDetailIngredientsView.vue";

import AccessHandler from "@/shared/access/AccessHandler.vue";
import {
  type RoleGroup,
  ApprovalGroup,
  ProductAppGroup,
  IngredientsAppGroup,
} from "@/shared/access/RoleGroups";

const main = useMainStore();

const roleGroups = [
  {
    roles: [
      ...ApprovalGroup.roles,
      ...ProductAppGroup.roles,
      ...IngredientsAppGroup.roles,
    ],
    validateRestrictionsAsync: async () => {
      return (
        main.companySummary?.denials.every(
          (d) => !d.IA || d.IA.toUpperCase() !== "ALL"
        ) ||
        main.companySummary?.denials.every(
          (d) => !d.Products || d.Products.toUpperCase() !== "ALL"
        )
      );
    },
  },
] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>

<style scoped lang="scss">
.page {
  &__header--container {
    display: flex;
    align-items: center;
    margin-top: 30px;
    gap: 12px;
  }

  &__title--text {
    font-size: 24px;
    line-height: 28px;
    font-weight: 600;
    text-transform: uppercase;
  }
}
</style>
